module.exports = __webpack_public_path__ + "static/media/sf-trial-1-wrong.09407451.mp3";